<template>
  <v-dialog
    v-model="dialog"
    transition="slide-y-transition"
    width="600"
    persistent
  >
    <template v-slot:activator="{ on, attrs }">
      <v-list-item
        v-bind="attrs"
        v-on="on"
      >
        <v-list-item-action></v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
    <v-card class="grey lighten-5">
      <v-card-title class="grey lighten-4">
        {{ title }}
        <v-spacer></v-spacer>
        <v-btn icon @click="dialog = !dialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-form ref="form">
          <v-autocomplete
            label="Nome"
            v-model="params.nome"
            :items="options.nome"
            item-text="nome" item-value="id"
            clearable
          />
          <v-autocomplete
            label="Número SID"
            v-model="params.sid"
            :items="options.sid"
            clearable
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn @click="reset()">Limpar</v-btn>
        <v-btn @click="addLayer()" color="primary">Pesquisar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
//import axios from 'axios'
import * as L from 'leaflet'
import { getBounds } from '@/domain/library'

import { desapropriacao, proxy } from '@/api/vue-exemplo'

export default {
  name: 'Desapropriacao',
  data: () => ({
    name: 'der:desapropriacao',
    title: 'Desapropriação',
    dialog: false,
    params: {
      nome: '',
      sid: ''
    },
    options: {
      nome: [],
      sid: []
    },
    template: [
      //{ text: 'id.sig', value: 'id.sig' },
      { text: 'Trecho', value: 'trecho' },
      { text: 'Regional', value: 'regional' },
      { text: 'CTD', value: 'ctd' },
      { text: 'Negociação', value: 'neg' },
      { text: 'Etapa Atual', value: 'et.atual' },
      { text: 'SID nº', value: 'sid' },
      { text: 'Proprietário', value: 'prop' },
      { text: 'Matrícula', value: 'matricula' },
      { text: 'Área (m²)', value: 'area.tn' },
      { text: 'Etapa desapropriação judicial', value: 'et.desap.j' },
      { text: 'Imissão de posse', value: 'imi.posse' },
      //{ text: 'labx', value: 'labx' },
      //{ text: 'laby', value: 'laby' },
      { text: 'Data Atual', value: 'data_atual' },
      //{ text: 'cores', value: 'cores' },
      { text: 'Termo', value: 'termo' }
    ]
  }),
  mounted () {
    this.getNome()
    this.getSid()
  },
  methods: {
    reset () {
      this.$refs.form.reset()

      this.removeLayer()
      this.$root.$emit('fitBounds', getBounds())

      this.dialog = false
    },
    addLayer () {
      if (this.geojson) {
        this.$root.$emit('removeGeoJson', this.geojson)
        this.$root.$emit('removeWmsLayer', this.wmsLayer)
      }

      var params = {
        service: 'wfs',
        version: '2.0.0',
        outputFormat: 'application/json',
        exceptions: 'application/json',
        request: 'GetFeature',
        typeNames: this.name,
        srsName: 'EPSG:4674'
      }
      
      var paramsWms = {
        layers: this.name,
        format: 'image/png',
        transparent: true,
        pane: 'overlayPane',
        title: this.title
      }

      if (this.params.nome) {
        params.cql_filter = "trecho='" + this.params.nome + "'"
        paramsWms.cql_filter = params.cql_filter
      }

      if(this.params.sid) {
        if(params.cql_filter) {
          params.cql_filter += "ANDsid='" + this.params.sid + "'"
        } else {
          params.cql_filter = "sid='" + this.params.sid + "'"
        }
        paramsWms.cql_filter = params.cql_filter
      }

      var ProxyWMS = L.TileLayer.WMS.extend({
        getTileUrl: function(coords) {
          var param = {
            url: L.TileLayer.WMS.prototype.getTileUrl.call(this, coords)
          }
          var proxy = process.env.VUE_APP_DER_API + '/geoProxy/geoserver'
          return proxy + L.Util.getParamString(param)
        }
      })

      this.wmsLayer = new ProxyWMS(process.env.VUE_APP_GEOSERVER, paramsWms)

      this.$root.$emit('addWmsLayer', this.wmsLayer, null, true)

      proxy.geoProxy({
        url: process.env.VUE_APP_GEOSERVER + L.Util.getParamString(params)
      })
        .then(response => {
          this.geojson = L.geoJson(response.data, {
            onEachFeature: (feature, layer) => {
              var popupContent = "<table>"
              for (var header of this.template) {
                if (feature.properties[header.value]) {
                  popupContent += "<tr><th>" + header.text + ":</th>" +
                    "<td>" + feature.properties[header.value] + "</td></tr>"
                }
              }

              popupContent += "</table>"
              layer.bindPopup(popupContent)
            },
            style: {
              opacity: 0,
              fillOpacity: 0
            }
          })

          this.$root.$emit('addGeoJson', this.geojson)
        })
        .catch(error => {
          console.log(error)
        })

      this.dialog = false
    },
    removeLayer () {
      if (this.geojson) {
        this.$root.$emit('removeGeoJson', this.geojson)
        this.$root.$emit('removeWmsLayer', this.wmsLayer)
      }
    },
    getNome () {
      desapropriacao.getNome()
        .then(response => {
          this.options.nome = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    getSid () {
      desapropriacao.getSid()
        .then(response => {
          this.options.sid = response.data
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>
